export default "__VITE_ASSET__bipjgTn2__"